export default "__VITE_ASSET__IQSrPRJI__"